import React, { Fragment } from "react";
import { useAppointment } from "../Provider";
import Input from "../../Common/InputField";

export const FullName = () => {
  const { state, addFullName } = useAppointment();

  return (
    <Fragment>
      <Input
        text="Full Name"
        placeholder="your full name..."
        textValue={state.fullName}
        isRequired
        change={(val) => addFullName(val.target.value)}
        type="text"
      />
    </Fragment>
  );
};

export default FullName;